<template>
  <div
    v-if="currentSubject"
    class="delete-course-modal modal fade"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-pdv">
      <div class="modal-content">
        <button
          id="closeDeleteCourseModalButton"
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="modal-title">
          <img class="images-title" src="/images/sincursos.png" alt="" />
          <div>
            <h3 class="title">LO SENTIMOS</h3>
            <p class="title-content">
              Los horarios disponibles de tu curso de
              <span :style="{ color: currentSubject.color }"
                ><img :src="currentSubject.iconSrc" alt="" />
                {{ currentSubject.displayName }}
                <span
                  class="mention-flat"
                  v-if="currentSubject.hasMention"
                  :style="{ background: currentSubject.color }"
                  >Mención</span
                ><span
                  class="mention-flat"
                  v-if="currentSubject.common"
                  :style="{ background: currentSubject.color }"
                  >Común</span
                ></span
              >
              se topan con los que seleccionaste antes. Elige una de estas
              opciones para continuar:
            </p>
          </div>
        </div>

        <ul>
          <li>
            <div>
              <p>
                <span>Eliminar este curso</span> de tu lista y comprar el resto
                de los cursos. Podrás tomar el curso de
                {{ currentSubject.name }} online.
              </p>
              <a
                @click.prevent="deleteSubject"
                data-dismiss="modal"
                href="#"
                class="btn-pdv-primary d-none d-md-inline-block"
                >ELIMINAR {{ currentSubject.name }}</a
              >
              <a
                @click.prevent="deleteSubject"
                data-dismiss="modal"
                href="#"
                class="btn-pdv-primary d-md-none btn-arrow-mobile"
                ><img src="/images/iconos/right-arrow-dark.svg" alt=""
              /></a>
            </div>
          </li>

          <li>
            <div>
              <p>
                <span>Volver a elegir</span> otra combinación de horarios para
                tus cursos.
              </p>
              <router-link
                :to="{ name: 'Step1' }"
                data-dismiss="modal"
                class="btn-pdv-primary d-none d-md-inline-block"
                >VOLVER A ELEGIR TODOS</router-link
              >
              <router-link
                :to="{ name: 'Step2' }"
                data-dismiss="modal"
                class="btn-pdv-primary d-md-none btn-arrow-mobile"
                ><img src="/images/iconos/right-arrow-dark.svg" alt=""
              /></router-link>
            </div>
          </li>

          <li>
            <div>
              <p>
                <span>Cambiar de sede</span> para ver los horarios disponibles
                en otras sedes.
              </p>
              <router-link
                :to="{ name: 'Step1' }"
                data-dismiss="modal"
                class="btn-pdv-primary d-none d-md-inline-block"
                >CAMBIAR DE SEDE</router-link
              >
              <router-link
                :to="{ name: 'Step1' }"
                data-dismiss="modal"
                class="btn-pdv-primary d-md-none btn-arrow-mobile"
                ><img src="/images/iconos/right-arrow-dark.svg" alt=""
              /></router-link>
            </div>
          </li>

          <li>
            <div>
              <p class="alternative-option-text d-none d-md-block">
                ¿No estás seguro qué hacer? Llámanos al +56 2 2994 9850!
              </p>
              <p class="alternative-option-text d-md-none">
                ¿No estás seguro qué hacer?
                <a
                  class="underline-link underline-link--secondary"
                  href="tel:6005002020"
                  >LLÁMANOS!</a
                >
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    currentSubject: Object
  },

  computed: {},

  methods: {
    deleteSubject() {
      this.$emit("buttonDeleteSubjectPressed");
    }
  }
};
</script>

<style scoped lang="scss">
.delete-course-modal {
  @include media-breakpoint-down(sm) {
    padding-right: 0 !important;
  }
  .modal-pdv {
    max-width: 951px;
    .modal-content {
      padding: 55px;
      border-radius: 1px;
      border: 1px solid #000;
      box-shadow: 0 0 12px 3px #00000038;
      @include media-breakpoint-down(sm) {
        padding: 25px 20px;
      }
    }
  }

  .btn-arrow-mobile {
    position: relative;
    width: 50px;
    height: 50px;
    img {
      position: absolute;
      left: 52%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  button.close {
    position: absolute;
    right: 15px;
    top: 15px;
    opacity: 1;
    span {
      font-size: 30px;
      color: $brown-light;
    }
  }

  .modal-title {
    display: flex;
    align-items: center;
    margin-bottom: 45px;
    .images-title {
      width: 98px;
      margin-right: 20px;
      @include media-breakpoint-down(sm) {
        display: none;
      }
    }
    h3 {
      font-size: 20px;
      line-height: 23px;
      margin-bottom: 12px;
      @include alternative-bold;
    }

    p {
      font-size: 18px;
      line-height: 25px;
      @include alternative-regular;
      margin-bottom: 0;
      span {
        line-height: 22px;
        @include alternative-regular;
        img {
          width: 32px;
          margin-top: -5px;
        }
      }
    }
  }

  ul {
    list-style: none;
    li {
      div {
        display: flex;
        align-items: center;
        margin-bottom: 32px;
        p {
          width: 65%;
          margin-bottom: 0;
          font-size: 16px;
          @include alternative-light-regular;
          line-height: 22px;
          position: relative;
          span {
            @include alternative-medium-regular;
          }

          &::before {
            content: "\2025";
            color: $yellow;
            font-weight: bold;
            display: inline-block;
            width: 2em;
            margin-left: -1em;
            position: absolute;
            top: 0;
          }

          @include media-breakpoint-down(sm) {
            width: fit-content;
            margin-right: 10px;
          }
        }
        a {
          width: 35%;
          text-align: center;
        }
      }
    }
  }

  .alternative-option-text {
    @include alternative-medium-regular;
  }
}

.mention-flat {
  font-size: 12px;
  @include alternative-light-regular;
  padding: 0 5px;
  color: #fff;
  margin-left: 3px;
  line-height: 18px;
}

.btn-pdv-primary {
  text-transform: uppercase;
}
</style>
